// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__h5S_F","button__delete":"Button_button__delete__3OBaZ","button__icon":"Button_button__icon__r3R7X"};